import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="siteFooter">
      <div>
        <Link to="/" className="logo" aria-label="Ayzen home">
          <img src="/assets/logo.png" alt="Ayzen" />
        </Link>
        Rawalpindi, Pakistan
        <br />
        0326 8615198
        <br />
        <a href="mailto:ayzenpk@gmail.com">ayzenpk@gmail.com</a>
      </div>
      <div>
        <Link to="/shop?category=Ready%20To%20Wear">Ready to Wear</Link>
        <Link to="/shop">New Arrival</Link>
        <Link to="/shop">Shop All</Link>
      </div>
      <div>
        <Link to="/about">About Us</Link>
        <Link to="/terms">Terms and Conditions</Link>
        <Link to="/contact">Contact Us</Link>
      </div>
    </footer>
  );
};

export default Footer;
